"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseTool_1 = require("./BaseTool");
const arcgis_1 = require("@terraformer/arcgis");
const geometry_engine_1 = __importDefault(require("./esri/geometry-engine"));
class PolygonMergeTool extends BaseTool_1.BaseTool {
    constructor() {
        super(...arguments);
        this.onComplete = (featureCollection, rectFeatureCollection) => __awaiter(this, void 0, void 0, function* () {
            let updated = [];
            const polygon = rectFeatureCollection.features[0].geometry;
            const esriPolygons = (0, arcgis_1.geojsonToArcGIS)(this.getGeometryCollection(featureCollection));
            const esriPolygon = (0, arcgis_1.geojsonToArcGIS)(polygon);
            const ge = yield geometry_engine_1.default.instance();
            const boundary = ge.union(esriPolygons);
            const intersection = ge.intersect(boundary, esriPolygon);
            if (intersection) {
                if (Array.isArray(intersection)) {
                    updated = updated.concat(intersection);
                }
                else {
                    updated.push(intersection);
                }
                for (const poly of esriPolygons) {
                    let res = [];
                    const differences = ge.difference(poly, esriPolygon);
                    if (differences) {
                        if (Array.isArray(differences)) {
                            res = res.concat(differences);
                        }
                        else {
                            res.push(differences);
                        }
                    }
                    updated = updated.concat(res);
                }
            }
            else {
                updated = updated.concat(esriPolygons);
            }
            const geometries = updated.map((poly) => (0, arcgis_1.arcgisToGeoJSON)(poly));
            return this.getFeatureCollection(geometries);
        });
    }
}
exports.default = new PolygonMergeTool();
